import React from "react";
import CTable from "components/common/Table";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import CardContent from "components/common/CardContent";
import Link from "components/common/Link";
import IconButton from "components/common/IconButton";
import Stack from "components/common/Stack";
import { InputLabel, ListItemText, MenuItem, Select } from "@mui/material";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Switch from "components/common/Switch";

function Vendor({
  data,
  citylist,
  handleOnchangeSelectCity,
  VendorListisLoading,
  handleStatusEnableVendor,
  selectCityDefaultValue,
  SelectedVendor,
}) {
  const columns = [
    {
      field: "vendors_name",
      headerName: "Name of Vendor ",
    },

    {
      field: "charging_station",
      headerName: "No of Charging Station",

      valueGetter: (v, d) => {
        const StationDetail = {
          pathname: "/charging",
          VendorDetailId: d.vendor_id,
          selectedCity: selectedCity,
        };
        return (
          <>
            <Link sx={{ textDecoration: "none" }} href={StationDetail}>
              {d.charging_station}
            </Link>
          </>
        );
      },
    },
    {
      field: "charge_point",
      headerName: "No of Charging Points",
    },

    {
      field: "actions",
      headerName: "Actions",
      valueGetter: (v, d) => {
        const StationDetail = {
          pathname: "/request/details",
          VendorDetailId: d.vendor_id,
        };
        const vendorconfig = {
          pathname: "/vendor/config",
          vendorconfigId: { id: d.vendor_id, name: d.vendors_name },
        };
        return (
          <>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              sx={{
                flexDirection: { xs: "column", md: "row", lg: "row" },
              }}
            >
              <Link href={StationDetail}>
                <VisibilityOutlinedIcon
                  sx={{ opacity: "0.8", width: "95%", marginTop: "3px" }}
                />
              </Link>

              <IconButton
                aria-label="edit"
                sx={{
                  color: "green",
                }}
              >
                <Link style={{ textDecoration: "none" }} to={vendorconfig}>
                  <SettingsOutlinedIcon
                    sx={{ fontSize: "21px ", cursor: "pointer" }}
                  />
                </Link>
              </IconButton>
              <Switch
                checked={d.status === 1 ? true : false}
                onClick={() => handleStatusEnableVendor(d.vendor_id, d.status)}
              ></Switch>
            </Stack>
          </>
        );
      },
    },
  ];
  const classes = useStyles();
  const [selectedCity, setSelectedCity] = React.useState("");
  return (
    <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
      <CardContent>
        <Text
          variant="h5"
          color="#707070"
          sx={{ fontSize: "24px", fontWeight: "600", marginBottom: "40px" }}
        >
          Vendors List
        </Text>
        <Box
          sx={{
            marginTop: "-4rem",
            float: "right",
          }}
        >
          <Box className={classes.city}>
            <InputLabel
              id="selected"
              sx={{ color: "#A2A7AE", fontSize: "14px" }}
            >
              Enter City
            </InputLabel>

            <Select
              sx={{
                width: "250px",
                height: "40px",
                marginBottom: "15px",
                fontSize: "14px",
              }}
              onChange={(car) => {
                setSelectedCity(car.target.value);
                handleOnchangeSelectCity(car.target.value);
              }}
              labelId="selected"
              label="Select City"
              id="selected"
              placeholder="Select city"
              value={
                selectCityDefaultValue
                  ? SelectedVendor
                    ? SelectedVendor
                    : selectCityDefaultValue
                  : SelectedVendor
                  ? SelectedVendor
                  : "all2"
              }
            >
              <MenuItem sx={{ fontSize: "14px" }} selected value={"all2"}>
                All
              </MenuItem>
              {citylist?.map((city, index) => (
                <MenuItem sx={{ fontSize: "14px" }} key={index} value={city}>
                  <ListItemText sx={{ fontSize: "14px" }} primary={city} />
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box></Box>
        </Box>

        <CTable
          columns={columns}
          data={data}
          isLoading={VendorListisLoading}
          pagination={true}
          localPagination={true}
          page={0}
          rowsPerPage={5}
        >
          
        </CTable>
      </CardContent>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  city: {
    "@media (max-width:768px)": {
      marginTop: "18px",
      marginLeft: "-10px",
    },
  },
}));
export default Vendor;
